import { createContext } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { CONTEXT_ROUTE, LOGIN_ROUTE } from '../constants/routes'
import { appsProps } from '../appConfig'


export const isSessionTimedOut = ({ response }) => {
    return response?.status === 401
}

export const isSessionTimedOutWithMsg = ({ response }) => {
    return response?.status === 401 && response?.data?.error === 'Session Timeout'
}

const defaultAppContext = appsProps.main

export const getContext = () => {

    const match = useRouteMatch(CONTEXT_ROUTE)

    let appContext = defaultAppContext

    if (match && match.params.appName) {
        appContext = appsProps[match.params.appName.toLowerCase()] || defaultAppContext
    }

    return appContext
}

export const getLoginUrl = location => {
    const match = useRouteMatch(CONTEXT_ROUTE)

    const appName = match.params.appName
    const appMatched = appExists(appName)

    if (appName && appMatched) {
        return `/${appName}${LOGIN_ROUTE}${location.search}`
    } else {
        return LOGIN_ROUTE
    }
}

export const appExists = appName => appName && Object.keys(appsProps).find(rec => rec === appName.toLowerCase() && rec !== 'main')

export default createContext({
    activeSession: false,
    application: defaultAppContext
})
